import { Routes } from '@angular/router';

export const CONTENT_ROUTES: Routes = [
  {
    path: 'error',
    loadChildren: () => import('../../modules/error/error.module').then(m => m.ErrorModule)
  },
  {
    path: 'delivery_sets',
    loadChildren: () => import('../../modules/delivery-set/delivery-set.module').then(m => m.DeliverySetModule)
  },
  {
    path: 'delivery_sets/batch',
    loadChildren: () => import('../../modules/delivery-set-register/delivery-set-register.module').then(m => m.DeliverySetRegisterModule)
  },
  {
    path: 'placement_relations',
    loadChildren: () => import('../../modules/placement-relation/placement-relation.module').then(m => m.PlacementRelationModule)
  },
  {
    path: 'placement_relations/batch',
    loadChildren: () => import('../../modules/placement-relation-register/placement-relation-register.module')
      .then(m => m.PlacementRelationRegisterModule)
  },
  {
    path: 'design_templates',
    loadChildren: () => import('../../modules/design-template/design-template.module').then(m => m.DesignTemplateModule)
  },
  {
    path: 'standard_design_templates',
    loadChildren: () => import('../../modules/standard-design-template/standard-design-template.module')
      .then(m => m.StandardDesignTemplateModule)
  },
  {
    path: 'ad_requests',
    loadChildren: () => import('../../modules/ad-request/ad-request.module').then(m => m.AdRequestModule)
  },
  {
    path: 'placements',
    loadChildren: () => import('../../modules/placement/placement.module').then(m => m.PlacementModule)
  },
  {
    path: 'tester_devices',
    loadChildren: () => import('../../modules/tester-device/tester-device.module').then(m => m.TesterDeviceModule)
  },
  {
    path: 'device_models',
    loadChildren: () => import('../../modules/device-model/device-model.module').then(m => m.DeviceModelModule)
  },
  {
    path: 'operating_systems',
    loadChildren: () => import('../../modules/os/os.module').then(m => m.OSModule)
  },
  {
    path: 'sdk_versions',
    loadChildren: () => import('../../modules/sdk-version/sdk-version.module').then(m => m.SDKVersionModule)
  },
  {
    path: 'device_model_groups',
    loadChildren: () => import('../../modules/device-model-group/device-model-group.module').then(m => m.DeviceModelGroupModule)
  },
  {
    path: 'os_groups',
    loadChildren: () => import('../../modules/os-group/os-group.module').then(m => m.OSGroupModule)
  },
  {
    path: 'deals',
    loadChildren: () => import('../../modules/deal/deal.module').then(m => m.DealModule)
  },
  {
    path: 'emergency_stop',
    loadChildren: () => import('../../modules/emergency-stop/emergency-stop.module').then(m => m.EmergencyStopModule)
  },
  {
    path: 'platforms',
    loadChildren: () => import('../../modules/platform/platform.module').then(m => m.PlatformModule)
  },
  {
    path: 'sdk_version_groups',
    loadChildren: () => import('../../modules/sdk-version-group/sdk-version-group.module')
      .then(m => m.SDKVersionGroupModule)
  },
  {
    path: 'platform_os_groups',
    loadChildren: () => import('../../modules/platform-os-group/platform-os-group.module').then(m => m.PlatformOSGroupModule)
  },
  {
    path: 'platform_sdk_version_groups',
    loadChildren: () => import('../../modules/platform-sdk-version-group/platform-sdk-version-group.module')
      .then(m => m.PlatformSDKVersionGroupModule)
  },
  {
    path: 'exchange_rates',
    loadChildren: () => import('../../modules/exchange-rate/exchange-rate.module').then(m => m.ExchangeRateModule)
  },
  {
    path: 'topics_urls',
    loadChildren: () => import('../../modules/topics-url/topics-url.module').then(m => m.TopicsURLModule)
  },
  {
    path: 'ad_request_parameter_templates',
    loadChildren: () =>
        import('../../modules/ad-request-parameter-template/ad-request-parameter-template.module')
            .then(m => m.AdRequestParameterTemplateModule),
  },
  {
    path: 'users',
    loadChildren: () => import('../../modules/user/user.module').then(m => m.UserModule)
  },
  {
    path: 'platform_reservations',
    loadChildren: () => import('../../modules/platform-reservation/platform-reservation.module').then(m => m.PlatformReservationModule)
  },
  {
    path: 'platform_reservations/batch',
    loadChildren: () => import('../../modules/platform-reservation-register/platform-reservation-register.module')
      .then(m => m.PlatformReservationRegisterModule)
  },
  {
    path: 'maintenance',
    loadChildren: () => import('../../modules/maintenance/maintenance.module').then(m => m.MaintenanceModule)
  },

  { path: '', redirectTo: 'delivery_sets', pathMatch: 'full' },
  { path: '**', redirectTo: '' }
];
